import apiAuctions from '../../api/apiAuctions'
const state = {
    brands: [],
    serverBrands: [],
    brandLabels: [],
    chassis: [],
    types: [],
    models: [],
    serverModels: [],
    activeTypeIndex: '',
    search: '',
    activeWeekday: '',
    auctions: [],
    regions: [],
    selectedRegions: [],
    query: {
        brand: '',
        'models': [],
        'grades': [],
        yearMin: 1970,
        yearMax: new Date().getFullYear(),
        kmsMin: null,
        kmsMax: null,
        priceMin: null,
        priceMax: null,
        ccMin: null,
        ccMax: null,
        date: null,
        'dates': [],
        carGrade: null,
        'chassis': [],
        'ports': [],
        'transmissions': [],
        'lots': [],
        'colors': [],
        'equipment': [],
        'auctions': [],
        'regions' : [],
        order_column: 'lot_date',
        order_type: 'DESC',
        page: 1,
        auctionType: 0,
    }
}

const getters = {
    getAllBrands: (state) => {
        return state.brands
    },
    topJapaneseBrands: state => {
        return state.brands.filter(b => {
            if ( b.top && b.country === "Japan" ) return b
        })
    },
    topOtherBrands: state => {
        return state.brands.filter(b => {
            if ( b.top && b.country !== "Japan" ) return b
        })
    },
    getJapaneseBrands: state => {
        return state.serverBrands.filter(b => {
            if (b.country === "JAPAN" ) return b
        })
    },
    getOtherBrands: state => {
        return state.serverBrands.filter(b => {
            if (b.country !== "JAPAN" ) return b
        })
    },
    getAllChassis: (state) => {
        return state.chassis
    },
    getQueryChassis: (state) => {
        return state.query["chassis"]
    },
    getQueryChassisByChassis: state => chassis => {
        return state.query['chassis'].filter(m => m === chassis)
    },
    getResultOrderColumn: (state) => {
        return state.query.order_column
    },
    getResultOrderType: (state) => {
        return state.query.order_type
    },
    getQuery: state => {
        return state.query
    },
    getQueryAuctionById: state => auction => {
        return state.query['auctions'].filter(a => a === auction)
    },
    getQueryAuctionMobile: state => {
        return state.query['auctions']
    },
    getQueryModelsByModel: state => model => {
        return state.query['models'].filter(m => m === model)
    },
    getQueryCompanyId: state => {
        return state.query.brand
    },
    getQueryModels: state => {
        return state.query.models
    },
    getBrandCarsByCountry: (state) => (country) => {
        return state.brands.filter(b => b.country === country)
    },
    getBrandLabels: (state) => {
        return state.brandLabels
    },
    getModelTypes: (state) => {
        return state.types
    },
    getActiveType: (state) => {
        return state.activeTypeIndex
    },
    getModels: (state) => {
        if (state.search) {
            return state
                .models
                .filter(m => m.name.toLowerCase().includes(state.search.toLowerCase()))
        } else {
            return state.models
        }
    },
    getServerModels: (state) => {
        return state.serverModels
    },
    getActiveModels: (state) => {
        if (state.search) {
            return state
                .models
                .filter(m => m.name.toLowerCase().includes(state.search.toLowerCase()))
        } else {
            const type = state.types[state.activeTypeIndex]
            return state.models.filter(m => m.type === type)
        }
    },
    getActiveWeekday: (state) => {
        return state.activeWeekday
    },
    getAuctions: (state) => {
        return state.auctions
    },
    getAuctionsByRegion: (state) => (region) => {
        return state.auctions.filter(a => {
            if (a.region === region && a.day === state.activeWeekday) return a
        })
    },
    getAllAuctionsByRegion: (state) => (region) => {
        return state.auctions.filter(a => {
            if (a.region === region) return a
        })
    },
    getRegions: (state) => {
        return state.regions
    },
    getAuctionsByDay: (state) => {
        return state.auctions.filter(a => a.day === state.activeWeekday)
    },
    getAuctionSearchQuery: (state) => {
        return state.query
    },
    getQueryYearMin: (state) => {
        return state.query.yearMin
    },
    getQueryYearMax: (state) => {
        return state.query.yearMax
    },
    getQueryKmMin: (state) => {
        return state.query.kmsMin
    },
    getQueryKmMax: (state) => {
        return state.query.kmsMax
    },
    getQueryPriceMin: (state) => {
        return state.query.priceMin
    },
    getQueryPriceMax: (state) => {
        return state.query.priceMax
    },
    getQueryCCMin: (state) => {
        return state.query.ccMin
    },
    getQueryCCMax: (state) => {
        return state.query.ccMax
    },
    getQueryCarGrade: (state) => {
        return state.query.carGrade
    },
    getQueryTransmission: (state) => {
        return state.query["transmissions"]
    },
    getQueryTransmissionStatus: (state) => (transmission) => {
        return state.query["transmissions"]
            .filter(t => t === transmission).length !== 0
    },
    getQueryAuctionGradeStatus: (state) => (grade) => {
        return state.query["grades"]
            .filter(g => g === grade).length !== 0
    },
    getQueryAuctionMobileGradeStatus: (state) => {
        return state.query["grades"]
    },
    getQueryEquipmentStatus: (state) => (equipment) => {
        return state.query["equipment"]
            .filter(eq => eq === equipment).length !== 0
    },
    getQueryLots: (state) => {
        return state.query["lots"]
    },
    getQueryMobileColor: (state) => {
        return state.query["colors"]
    },
    getQueryColorStatus: (state) => (color) => {
        return state.query["colors"].filter(c => c === color).length !== 0
    },
    getQueryLotDate: (state) => {
        return state.query['date']
    },
    getQueryRegions: (state) => {
        return state.query['regions']
    },
    getQueryAuctionPorts: (state) => {
        return state.query['ports']
    },
    getQueryAuctions: (state) => {
        return state.query['auctions']
    },
    getAuctionType: (state) => {
        return state.query["auctionType"]
    },
    getQueryDatesByDate: state => date => {
        return state.query['dates'].filter(m => m === date)
    },
    getQueryAuctionsHasRegion: (state) => (region) =>  {
        let auctions = [];

        for(let auction in state.auctions){
            for(let filter in state.query['auctions']){

                if(state.auctions[auction].id === state.query['auctions'][filter]){
                    auctions.push(state.auctions[auction]);
                }
            }
        }

        let found = false;

        for(let i = 0; i < auctions.length; i++) {
            if (auctions[i].region === region) {
                found = true;
                break;
            }
        }

        return found
    }
}

// TODO 1. on brand change clear query params
// TODO 2. on Auctions click make new query object
const actions = {
    fetchBrandsFromServer: ({ commit }) => {
        apiAuctions
            .getCarMarkas()
            .then((response) => {
                commit('mutateServerBrands', response.data)
            })
            .catch((error) => {
                console.log(error)
            })
    },
    fetchBrands: ({ commit }) => {
        commit('mutateBrands', apiAuctions.getCarBrands())
    },
    fetchBrandLabels: ({ commit }) => {
        commit('mutateBrandLabels', apiAuctions.getCarBrandLabels())
    },
    fetchBrandModels: ({ commit, dispatch }, brandId) => {
        dispatch('setStatusLoading')
        apiAuctions.getBrandModels(brandId)
            .then((response) => {
                commit('mutateBrandModelsAndTypes', response.data)
                dispatch('setStatusLoaded')
            })
            .catch((error) => {
                console.log(error)
            })
    },
    fetchBrandModelsByBrandId: ({ commit, dispatch}, brandId) => {
        dispatch('setStatusLoading')
        apiAuctions
            .getModelsByBrandId(brandId)
            .then((response) => {
                commit('mutateServerModels', response.data)
                dispatch('setStatusLoaded')
            })
            .catch((error) => {
                console.log(error)
            })
    },
    fetchAllChassisByModelName: ({ commit }, modelName) => {
        apiAuctions
            .getChassisByModelName(modelName)
            .then((response) => {
                commit('mutateChassis', response.data)
            })
            .catch((error) => {
                console.log(error)
            })
    },
    removeChassisFromQuery: ({ commit }, model) => {
        commit('removeChassisFromQuery', model)
    },
    handleQueryChassis: ({ commit }, value) => {
        commit('handleQueryChassis', value)
    },
    setBrandModelToDefault: ({ commit }) => {
        commit('setQueryCompanyId', '')
        commit('handleQueryModels', [])
    },
    setChassisToDefault: ({ commit }) => {
        commit('mutateChassis', [])
        commit('resetChassisQuery')
    },
    resetChassisQuery: ({ commit }) => {
        commit('resetChassisQuery')
    },
    setChassisQuery: ({ commit }, chassis) => {
        commit('setChassisQuery', chassis)
    },
    addAuctionToQueryAdvanceFilter: ({commit}, newValue) => {
        commit('pushAuctionToQueryAdvanceFilter', newValue)
    },
    setResultOrderColumn: ({ commit }, newValue) => {
        commit('mutateResultOrderColumn', newValue)
    },
    setResultOrderType: ({ commit }, newValue) => {
        commit('mutateResultOrderType', newValue)
    },
    fetchAuctionsData: ({ commit , dispatch}) => {
        dispatch('setStatusLoading')
        apiAuctions.getAuctionsData()
            .then((response) => {
                commit('changeAuctions', response.data.auctions)
                commit('changeRegions', response.data.regions)
                dispatch('setStatusLoaded')
            })
            .catch((error) => console.log(error))
    },
    changeActiveElement: ({ commit }, newElementIndex) => {
        commit('changeActiveElement', newElementIndex)
    },
    changeActiveWeekday: ({ commit }, value) => {
        commit('changeActiveWeekday', value)
    },
    changeModelSearchValue: ({commit}, value) => {
        commit('changeSearchValue', value)
    },
    changeQueryCompanyId: ({ commit }, value) => {
        commit('setQueryCompanyId', value)
    },
    addModelToQuery: ({ commit }, model) => {
        commit('addModelToQuery', model)
    },
    removeModelFromQuery: ({ commit }, model) => {
        commit('removeModelFromQuery', model)
    },
    removeModels: ({ commit }) => {
        commit('removeModels')
    },
    removeLotFromQuery: ({ commit }, model) => {
        commit('removeLotFromQuery', model)
    },
    addAuctionToQuery: ({ commit }, auction) => {
        commit('addAuctionToQuery', auction)
    },
    removeAuctionFromQuery: ({ commit }, auction) => {
        commit('removeAuctionFromQuery', auction)
    },
    addAllAuctionsByRegion: ({ commit, getters }, region) => {
        const auctions = getters.getAuctionsByRegion(region).map(a => a.id)
        commit('handleAuctionsQuery', auctions)
    },
    addAllAuctionsByRegionForAllDays: ({ commit, getters }, region) => {
        const auctions = getters.getAllAuctionsByRegion(region).map(a => a.id)
        commit('handleAuctionsQuery', auctions)
    },
    addAllAuctionsByActiveDay: ({ commit, getters }) => {
        const auctions = getters.getAuctionsByDay.map(a => a.id)
        commit('handleAuctionsQuery', auctions)
    },
    addNewYearRangeMinValue: ({ commit }, value) => {
        commit('changeYearRangeMin', value)
    },
    addNewYearRangeMaxValue: ({ commit }, value) => {
        commit('changeYearRangeMax', value)
    },
    addNewKmRangeMinValue: ({ commit }, value) => {
        commit('changeKmRangeMin', value)
    },
    addNewKmRangeMaxValue: ({ commit }, value) => {
        commit('changeKmRangeMax', value)
    },
    addNewPriceRangeMinValue: ({ commit }, value) => {
        commit('changePriceRangeMin', value)
    },
    addNewPriceRangeMaxValue: ({ commit }, value) => {
        commit('changePriceRangeMax', value)
    },
    addNewCCRangeMinValue: ({ commit }, value) => {
        commit('changeCCRangeMin', value)
    },
    addNewCCRangeMaxValue: ({ commit }, value) => {
        commit('changeCCRangeMax', value)
    },
    addNewCarGrade: ({ commit }, value) => {
        commit('changeCarGrade', value)
    },
    handleQueryTransmission: ({ commit }, value) => {
        commit('handleQueryTransmission', value)
    },
    setTransmission: ({ commit }, value) => {
        commit('setTransmission', value)
    },
    handleQueryGrades: ({ commit }, value) => {
        commit('handleQueryGrades', value)
    },
    handleQueryMobileGrades: ({ commit }, value) => {
        commit('handleQueryMobileGrades', value)
    },
    handleQueryEquipment: ({ commit }, value) => {
        commit('handleQueryEquipment', value)
    },
    handleQueryLots: ({ commit }, value) => {
        commit('handleQueryLots', value)
    },
    handleQueryModels: ({ commit }, value) => {
        commit('handleQueryModels', value)
    },
    handleQueryColor: ({ commit }, value) => {
        commit('handleQueryColor', value)
    },
    handleQueryMobileColor: ({ commit }, value) => {
        commit('handleQueryMobileColor', value)
    },
    handleQueryMobilePort: ({ commit, getters }, value) => {
        let auctions = [];
        value.forEach((port) => {
            auctions = auctions.concat(getters.getAllAuctionsByRegion(port).map(a => a.id))
        })
        commit('handleAuctionsMobileQuery', auctions)
        commit('handleAuctionsPort', value)
    },
    setQueryToDefault: ({commit}) => {
        commit('setDefaultAuctionQuery')
    },
    handleNewLotDate: ({commit}, value) => {
        commit('handleLotDateQuery', value)
    },
    setQueryToNewValue: ({commit}, value) => {
        commit('changeQuery', value)
    },
    addSelectedRegion: ({commit}, value) => {
        commit('pushSelectedRegion', value)
    },
    removeSelectedRegion: ({commit}, value) => {
        commit('filterSelectedRegion', value)
    },
    setAuctionType: ({commit}, value) => {
        commit('changeAuctionType', value)
    },
    setModelsToDefault: ({commit}) => {
        commit('mutateBrandModelsAndTypes', { models: [], types: [] })
    },
    addDateToQuery: ({ commit }, date) => {
        commit('pushDateToQuery', date)
    },
    removeDateFromQuery: ({ commit }, date) => {
        commit('filterDateFromQuery', date)
    },
    setSearchQueryPageNumber: ({commit}, value) => {
        commit('updatePageNumber', value)
    }

}

const mutations = {
    mutateChassis: (state, value) => {
        state.chassis = value
    },
    handleQueryChassis: (state, value) => {
        state.query["chassis"].push(value)
    },
    removeChassisFromQuery: (state, chassis) => {
        state.query['chassis'] = state.query['chassis'].filter(m => m !== chassis)
    },
    resetChassisQuery: (state) => {
        state.query['chassis'] = []
    },
    setChassisQuery: (state, chassis) => {
        state.query['chassis'] = chassis
    },
    mutateServerModels: (state, value) => {
        state.serverModels = value
    },
    filterSelectedRegion: (state, value) => {
        state.selectedRegions = state.selectedRegions.filter(m => m !== value)
    },
    pushSelectedRegion: (state, newValue) => {
        state.query['regions'] = newValue
    },
    mutateResultOrderColumn: (state, newValue) => {
        state.query.order_column = newValue
    },
    mutateResultOrderType: (state, newValue) => {
        state.query.order_type = newValue
    },
    updatePageNumber: (state, pageNumber) => {
        state.query.page = pageNumber
    },
    mutateBrands: (state, newBrands) => {
        state.brands = newBrands
    },
    mutateServerBrands: (state, newBrands) => {
        state.serverBrands = newBrands
    },
    mutateBrandLabels: (state, brands) => {
        state.brandLabels = brands
    },
    mutateBrandModelsAndTypes: (state, data) => {
        state.models = data.models
        state.types = data.types
    },
    changeActiveElement: (state, newElementIndex) => {
        state.activeTypeIndex = newElementIndex
    },
    changeSearchValue: (state, value) => {
        state.search = value
    },
    changeActiveWeekday: (state, value) => {
        state.activeWeekday = value
    },
    changeAuctions: (state, data) => {
        state.auctions = data
    },
    changeRegions: (state, data) => {
        state.regions = data
    },
    setQueryCompanyId: (state, companyId) => {
        state.query.brand = companyId
    },
    addModelToQuery: (state, model) => {
        state.query['models'].push(model)
    },
    removeModelFromQuery: (state, model) => {
        state.query['models'] = state.query['models'].filter(m => m !== model)
    },
    removeModels: (state) => {
        state.query['models'] = []
    },
    removeLotFromQuery: (state, lots) => {
        state.query['lots'] = state.query['lots'].filter(m => m !== lots)
    },
    addAuctionToQuery: (state, auction) => {
        state.query['auctions'].push(auction)
    },
    removeAuctionFromQuery: (state, auction) => {
        state.query['auctions'] = state.query['auctions'].filter(a => a !== auction)
    },
    handleAuctionsQuery: (state, auctions) => {
        // TODO check containers exisitngCount > newCount, existingCount == newCount, existingCoung == 0
        const existing = state.query['auctions']
        if ( existing.length === 0 ) {
            state.query['auctions'] = auctions
        } else {
            const filterExisting = existing.filter(ex => !auctions.includes(ex))
            const filterNewAuctions = auctions.filter(ex => !existing.includes(ex))
            state.query['auctions'] = filterExisting.concat(filterNewAuctions)
        }
    },
    handleAuctionsMobileQuery: (state, auctions) => {
        state.query['auctions'] = auctions
    },
    handleAuctionsPort: (state, ports) => {
        state.query['ports'] = ports
    },
    changeYearRangeMin: (state, newValue) => {
        state.query.yearMin = newValue
    },
    changeYearRangeMax: (state, newValue) => {
        state.query.yearMax = newValue
    },
    changeKmRangeMin: (state, newValue) => {
        state.query.kmsMin = newValue
    },
    changeKmRangeMax: (state, newValue) => {
        state.query.kmsMax = newValue
    },
    changePriceRangeMin: (state, newValue) => {
        state.query.priceMin = newValue
    },
    changePriceRangeMax: (state, newValue) => {
        state.query.priceMax = newValue
    },
    changeCCRangeMin: (state, newValue) => {
        state.query.ccMin = newValue
    },
    changeCCRangeMax: (state, newValue) => {
        state.query.ccMax = newValue
    },
    changeCarGrade: (state, newValue) => {
        state.query.carGrade = newValue
    },
    handleLotDateQuery: (state, newValue) => {
        state.query.date = newValue
    },
    handleQueryTransmission: (state, value) => {
         if (state.query["transmissions"].filter(t => t === value).length === 0)  {
             state.query["transmissions"].push(value)
         } else {
             state.query["transmissions"] = state.query["transmissions"].filter(t => t !== value)
         }
    },
    setTransmission: (state, value) => {
        state.query["transmissions"] = value
    },
    handleQueryGrades: (state, value) => {
        if (state.query["grades"].filter(g => g === value).length === 0)  {
            state.query["grades"].push(value)
        } else {
            state.query["grades"] = state.query["grades"].filter(g => g !== value)
        }
    },
    handleQueryMobileGrades: (state, value) => {
        state.query["grades"] = value
    },
    handleQueryEquipment: (state, value) => {
        if (state.query["equipment"].filter(eq => eq === value).length === 0)  {
            state.query["equipment"].push(value)
        } else {
            state.query["equipment"] = state.query["equipment"].filter(eq => eq !== value)
        }
    },
    handleQueryLots: (state, value) => {
        state.query["lots"].push(value)
    },
    handleQueryModels: (state, value) => {
        state.query["models"] = value
    },
    handleQueryMobileColor: (state, value) => {
        state.query["colors"] = value
    },
    handleQueryColor: (state, value) => {
        if (state.query["colors"].filter(c => c === value).length === 0)  {
            state.query["colors"].push(value)
        } else {
            state.query["colors"] = state.query["colors"].filter(c => c !== value)
        }
    },
    setDefaultAuctionQuery: (state) => {
        const defaultQ = {
            brand: '',
            'models': [],
            'grades': [],
            yearMin: 1970,
            yearMax: new Date().getFullYear(),
            kmsMin: null,
            kmsMax: null,
            priceMin: null,
            priceMax: null,
            ccMin: null,
            ccMax: null,
            date: null,
            'dates': [],
            carGrade: null,
            'chassis': [],
            'transmissions': [],
            'lots': [],
            'colors': [],
            'equipment': [],
            'auctions': [],
            'regions': [],
            'ports': [],
            order_column: 'lot_date',
            order_type: 'DESC',
            page: 1,
            auctionType: 0
        }
        state.query = Object.assign({}, defaultQ)
    },
    changeQuery: (state, value) => {
        state.query = value
    },
    pushAuctionToQueryAdvanceFilter: (state, value) => {
        state.query['auctions'] = value
    },
    changeAuctionType: (state, value) => {
        state.query['auctionType'] = value
    },
    pushDateToQuery: (state, date) => {
        state.query['dates'].push(date)
    },
    filterDateFromQuery: (state, date) => {
        state.query['dates'] = state.query['dates'].filter(m => m !== date)
    },


}

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/auctions.js